import React from 'react';

import stats from '../../../json/captainStats.json';
import CreateCharacter from './CreateCharacter';


/**
 *
 */
function Captain(props){
  return (
    <CreateCharacter
      state={props.state}
      stateName={props.stateName}
      updateState={props.updateState}
      resetState={props.resetState}
      stats={stats}
    />
  );
}

export default Captain;
